import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Public
export const createLead = (data) => api.post("/leads", data).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const fetchGuides = () => api.get("/guides").then((r) => r.data);

// Auth
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const exchangeSession = (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data);
export const logout = () => api.post("/auth/logout").then((r) => r.data);

// Portal (client)
export const fetchDashboard = () => api.get("/portal/dashboard").then((r) => r.data);
export const fetchPortalDocuments = () => api.get("/portal/documents").then((r) => r.data);
export const portalDownloadUrl = (docId) => `${API_BASE}/portal/documents/${docId}/download`;
export const fetchPortalMessages = () => api.get("/portal/messages").then((r) => r.data);
export const sendPortalMessage = (body) => api.post("/portal/messages", { body }).then((r) => r.data);
export const fetchPortalBookings = () => api.get("/portal/bookings").then((r) => r.data);
export const createPortalBooking = (data) => api.post("/portal/bookings", data).then((r) => r.data);

// Admin
export const fetchAdminClients = () => api.get("/admin/clients").then((r) => r.data);
export const fetchAdminClient = (userId) => api.get(`/admin/clients/${userId}`).then((r) => r.data);
export const adminCreateCase = (data) => api.post("/admin/cases", data).then((r) => r.data);
export const adminUpdateCase = (caseId, data) => api.patch(`/admin/cases/${caseId}`, data).then((r) => r.data);
export const adminDeleteCase = (caseId) => api.delete(`/admin/cases/${caseId}`).then((r) => r.data);
export const adminToggleMilestone = (caseId, milestone_key, completed) =>
  api.post(`/admin/cases/${caseId}/milestone`, { milestone_key, completed }).then((r) => r.data);
export const adminUploadDocument = (userId, file) => {
  const fd = new FormData();
  fd.append("user_id", userId);
  fd.append("file", file);
  return api.post("/admin/documents", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const adminDeleteDocument = (docId) => api.delete(`/admin/documents/${docId}`).then((r) => r.data);
export const adminSendMessage = (thread_user_id, body) =>
  api.post("/admin/messages", { thread_user_id, body }).then((r) => r.data);
export const adminUpdateBooking = (bookingId, data) => api.patch(`/admin/bookings/${bookingId}`, data).then((r) => r.data);

// Engagements & Payments
export const adminCreateEngagement = (data) => api.post("/admin/engagements", data).then((r) => r.data);
export const adminListEngagements = () => api.get("/admin/engagements").then((r) => r.data);
export const adminEngagementDetail = (id) => api.get(`/admin/engagements/${id}`).then((r) => r.data);
export const adminDeleteEngagement = (id) => api.delete(`/admin/engagements/${id}`).then((r) => r.data);
export const fetchPortalEngagements = () => api.get("/portal/engagements").then((r) => r.data);
export const createCheckout = (installment_id) =>
  api.post("/payments/checkout", { installment_id, origin_url: window.location.origin }).then((r) => r.data);
export const fetchPaymentStatus = (session_id) => api.get(`/payments/status/${session_id}`).then((r) => r.data);
